import React, { FC, ReactNode, useState } from 'react';
import { KitchenItemRequestContext } from './context';
import { KitchenRequestType } from 'models/item-request.model';

const KitchenItemRequestProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [itemRequestToEdit, setItemRequestToEdit] = useState<KitchenRequestType | any>(null);
  return (
    <KitchenItemRequestContext.Provider
      value={{
        itemRequestToEdit,
        setItemRequestToEdit
      }}>
      {children}
    </KitchenItemRequestContext.Provider>
  );
};

export default KitchenItemRequestProvider;
